import React from 'react'
export const SearchFormContext = React.createContext({
  collpasedConfig: {
    showCollapsed: true,
    collapse: true,
    collapsedNumber: 1,
    defaultCollapsed: true
  },
  onCollpased: () => {},
  formRef: {}
});
